import TyCellSuper from './TyCellSuper.vue'
export default TyCellSuper



// WEBPACK FOOTER //
// ./src/components/ty-cell-super/index.js